import { useEffect } from "react"
import { useState } from "react"
import { useFetch } from "../../../hooks/useFetch"
import { listDocumentsAdminService } from "../services/listDocumentsAdmin.service"

export const useDocumentsAdminQuery = () => {
  const fetchData = useFetch()
  const [documentsAdmin, setDocumentsAdmin] = useState({})
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    const fetchDocumentsAdmin = async () => {
      try {
        setLoading(true)
        const response = await listDocumentsAdminService(fetchData)()
        setDocumentsAdmin(response.data || {})
      } catch (e) {
        console.error(e)
      } finally {
        setLoading(false)
      }
    }

    fetchDocumentsAdmin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  return {
    documentsAdmin,
    loading,
    refresh: () => setRefresh(!refresh)
  }
}
